module.exports = __webpack_public_path__ + "fonts/SFUIText-Bold.0455014a.eot";